const PURCHASE_TARGET_ID = 'pack-product-purchase';

function purchaseHeaderOffset() {
  const fromCss = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('--header-height')
  );
  if (!Number.isNaN(fromCss) && fromCss > 0) return fromCss + 16;
  const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
  return header ? header.getBoundingClientRect().height + 16 : 88;
}

function scrollToPurchaseBlock() {
  const target = document.getElementById(PURCHASE_TARGET_ID);
  if (!target) return;
  const top = target.getBoundingClientRect().top + window.scrollY - purchaseHeaderOffset();
  window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'smooth' });
  target.focus({ preventScroll: true });
}

if (!customElements.get('pack-product-bundle-gallery')) {
  customElements.define(
    'pack-product-bundle-gallery',
    class PackProductBundleGallery extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('[data-bundle-main-image]');
        this.thumbs = this.querySelectorAll('[data-bundle-thumb]');

        const scrollTrigger = this.querySelector('[data-bundle-scroll-to-purchase]');
        if (scrollTrigger) {
          scrollTrigger.addEventListener('click', () => scrollToPurchaseBlock());
        }

        if (!this.mainImage || !this.thumbs.length) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.selectThumb(thumb));
        });
      }

      selectThumb(thumb) {
        const url = thumb.dataset.mediaUrl;
        const srcset = thumb.dataset.mediaSrcset;
        const alt = thumb.dataset.mediaAlt;
        if (!url) return;

        this.mainImage.src = url;
        if (srcset) {
          this.mainImage.srcset = srcset;
        } else {
          this.mainImage.removeAttribute('srcset');
        }
        if (alt) {
          this.mainImage.alt = alt;
        }

        this.thumbs.forEach((button) => {
          button.classList.toggle('is-active', button === thumb);
          button.setAttribute('aria-current', button === thumb ? 'true' : 'false');
        });
      }
    }
  );
}
